module.exports = __webpack_public_path__ + "img/banner1.f0717455.jpg";